export default __webpack_public_path__ + "static/vamarhan2019-32d0f237582c06b6be41739f87f90d75.png";